module.exports = __webpack_public_path__ + "img/icon-create-account.7e514742.svg";